import { imgPath } from '~common/utilities/ImgUrl';
import { Messages } from '~src/codegen/Localize';
import { ContentTypeFilterClause,MixedContentItemDefinition, SpaceDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { FlowCard } from '~src/flow/components/cardView/FlowCard';
import { Flows } from '~src/flow/resources/Flows';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { FlowContentType } from '~src/spacesPlatform/models/ContentTypes';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';

import { getGenericDefaultFilters } from '../../contentDefinitions/getDefaultFilters';

export const FlowDefinition: MixedContentItemDefinition & SpaceDefinition<'flow'> = {
  itemType: 'flow',
  contentType: 'flow',
  singularName: Messages.flow,
  pluralName: Messages.flows,
  emptyStateMessage: Messages.flowsEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_Flows,
  contentFilterKeys: FlowContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: FlowCard,
  listViewIconUrl: imgPath('flow_18px-large.svg'),
  filterClause: ServerFilterClauses.ContentType(['flow']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.flowUrl(contentId),
  getBasicQuery: () => {
    return Flows.all().withExtraParams(FlowContentType.extraQueryParams);
  },
  fieldValueResourceType: 'flow',
  getContentInfo: () => {
    throw new Error('getContentInfo is not implemented for flow');
  },
  headerIconPath: () => imgPath('spaces_masthead_flow.svg'),
  supportedDisplayModes: ['list', 'thumbnail'],
};
